import React from 'react';
import { MenuProps } from 'antd';
import { getPage } from "routers/router";
import {
  ArrowRightOutlined,
  HomeOutlined,
  BookOutlined,
  CameraOutlined,
  CloudServerOutlined,
  ToolOutlined,
  DatabaseOutlined,
  SnippetsOutlined,
  FormOutlined,
  EditOutlined,
  FileAddOutlined,
  FileImageOutlined,
  FileSearchOutlined,
  LaptopOutlined,
  ImportOutlined,
  FundOutlined,
  LineChartOutlined,
  ProjectOutlined,
  ReadOutlined,
  ScissorOutlined,
  SearchOutlined,
  TeamOutlined,
  GroupOutlined,
  TableOutlined,
  UserOutlined
} from '@ant-design/icons';


/**
 * 根据routeKey生成一个菜单链接
 * @param routeKey 定义在router.ts里面每个页面的key
 * @param title 在导航栏中显示的链接名称，可选，默认为页面在router.ts中定义的标题
 * @returns 
 */
 const itemOfPage = (routeKey:string, title?:string) => {
    const page = getPage(routeKey);
    const path = page.path;
    const label = title || page.title;

    return {label, key: routeKey, path}
}


/**
* 导航菜单设计
*/
const items: MenuProps['items'] = [
  {
      ...itemOfPage("index"), 
      icon: <HomeOutlined />
  },
  {
    label: "数据查询",
    icon : <FileSearchOutlined />,
    key : "query",
    children: [
      {
        ...itemOfPage("queryLabelBoards"),
        icon:<SearchOutlined />
      },
      {
        ...itemOfPage("queryAdmissionRecords"),
        icon:<SearchOutlined />
      }
    ]
  },
  {
    label: "工作台",
    icon : <FormOutlined />,
    key : "PROJECT_MEMBER:labelingWorkbench",
    children: [
      {
        type: "group",
        label: "注: 只有科研项目成员可以访问",
        children: [
        {
          ...itemOfPage("labelingMgmt"),
          icon:<SnippetsOutlined/>
        },
        {
          ...itemOfPage("workbench"),
          icon:<EditOutlined />
        },
        {
          ...itemOfPage("workbenchOfReviewer"),
          icon:<TeamOutlined />
        },
        {
          ...itemOfPage("workloadStats"),
          icon:<FundOutlined/>
        }]
      }
    ]
  },
  
  {
    label: "科研项目管理",
    icon : <DatabaseOutlined />,
    key : "PROJECT_MANAGER:projectManagement",
    children: [
      {
        type: "group",
        label: "注: 只有科研项目负责人可以访问",
        children: [
          {
            ...itemOfPage("researchProject"),
            icon:<ProjectOutlined />
          },
          {
            ...itemOfPage("researchProjectMember"),
            icon:<TeamOutlined />
          },
          {
            ...itemOfPage("dataGroupAndLabelScheme"),
            icon:<GroupOutlined/>
          },
          {
            ...itemOfPage("researchDataImportFromFCIS"),
            icon:<ImportOutlined />
          },
          {
            ...itemOfPage("researchDataImportFromDataset"),
            icon:<ImportOutlined/>
          },
          {
            ...itemOfPage("researchDataMgmt"),
            icon:<TableOutlined />
          },
          {
            ...itemOfPage("assignLabelingTask"),
            icon:<LaptopOutlined />
          }
        ]
      }
    ]
  },
  {
    label: "样例素材工作台",
    icon : <ReadOutlined />,
    key : "MATERIAL_REPOSITORY_MEMBER:materialRepositoryData",
    children: [
      {
        type: "group",
        label: "注: 只有样例素材库成员可以访问",
        children: [
        {
            ...itemOfPage("materialDataMgmt"),
            icon:<EditOutlined />
        },
        {
            ...itemOfPage("addEfmSlicesToMaterialRepository"),
            icon: <FileAddOutlined />
        }
        ]
      }
    ]
  },
  {
    label: "样例素材库管理",
    icon : <ReadOutlined />,
    key : "MATERIAL_REPOSITORY_MANAGER:materialRepositoryManagement",
    children: [
      {
        type: "group",
        label: "注: 只有样例素材库负责人可以访问",
        children: [
          {
              ...itemOfPage("materialRepository"),
              icon:<CloudServerOutlined />
          },
          {
              ...itemOfPage("materialRepositoryMember"),
              icon:<TeamOutlined />
          }
        ]
      }
    ]
  },
  {...itemOfPage("takePhotos"),
      icon:<CameraOutlined />
  },
  {
    label: "系统管理",
    icon: <ToolOutlined />,
    key: "SUPER_ADMIN:system",
    children: [
      {
       ...itemOfPage("users"),
       icon:<UserOutlined />
      },
      {
        ...itemOfPage("adminManageResearchProject"),
       icon:<ProjectOutlined />
      },
      {
        ...itemOfPage("adminManageMaterialRepository"),
       icon:<ScissorOutlined />
      },
      {
        ...itemOfPage("manageGlobalEfmData"),
        icon: <LineChartOutlined />
      }
    ]
  }
];

export default items;